<script setup>
import { HrSpinner } from '../primitives';

/**
 * Loading spinner — indeterminate indicator for page or section initial content load.
 *
 * @status recommended
 * @group status-feedback
 * @useWhen A page or major section is fetching its primary content
 * @avoidWhen Background activity within an already-loaded view — use HrActivitySpinner
 * @related HrActivitySpinner
 */
defineOptions({ name: 'HrLoadingSpinner' });

defineProps({
  /** Spinner size; accepts CSS length values (e.g. `'32px'`, `'3em'`). Defaults to the theme standard. */
  size: {
    type: String,
    default: undefined,
  },
  /**
   * Legacy props forwarded to the underlying Quasar component.
   * @deprecated Only for backwards compatibility with the legacy theme — ignored when a design system theme is active.
   */
  legacyProps: {
    type: Object,
    default: () => ({}),
  },
});
</script>

<template>
  <hr-spinner
    :size="size"
    :legacy-props="legacyProps"
  />
</template>
